module.exports = __webpack_public_path__ + "img/ic_life_flower.92098b0a.png";